import { type ColumnsState, createColumnsHook } from '@features/allocation';

/** Ordem de exibição. Código Axis e nome ficam de fora: identificam a linha, sempre visíveis (entre contrato e cliente). */
export const PROJECT_COLUMNS = [
  'unit',
  'contract',
  'client',
  'status',
  'startDate',
  'endDate',
  'projectManager',
  'operationManager',
  'accountDirector',
  'internal',
  'pool',
] as const;

export type ProjectColumn = (typeof PROJECT_COLUMNS)[number];

/** Chaves do namespace `projetos`. */
export const PROJECT_COLUMN_LABEL_KEYS = {
  unit: 'colunas.unidade',
  contract: 'colunas.contrato',
  client: 'colunas.cliente',
  status: 'colunas.situacao',
  startDate: 'colunas.inicio',
  endDate: 'colunas.termino',
  projectManager: 'colunas.gerenteProjeto',
  operationManager: 'colunas.gerenteOperacao',
  accountDirector: 'colunas.diretorConta',
  internal: 'colunas.interno',
  pool: 'colunas.pool',
} as const satisfies Record<ProjectColumn, string>;

export const useProjectColumns = createColumnsHook({
  columns: PROJECT_COLUMNS,
  // Cliente e situação existem no seletor, mas a tela abre sem elas.
  defaultColumns: PROJECT_COLUMNS.filter((column) => column !== 'client' && column !== 'status'),
  storageKey: 'project-list-table-columns',
  version: 3,
});

export type ProjectColumnsState = ColumnsState<ProjectColumn>;
